/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "@/components/ui/tabs"

type Props = {
    id?: string;
};

const BlogItem: React.FC<Props> = (props): JSX.Element => {
    return (
        <section className="container flex flex-col">
            <div className="flex flex-col w-full">
                <h2 className="text-lg py-2 text-center font-semibold">
                    Blog Item
                </h2>

                <Tabs defaultValue="example">
                    <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
                        <TabsTrigger value="example">Example</TabsTrigger>
                        <TabsTrigger value="code">Code</TabsTrigger>
                    </TabsList>

                    <TabsContent value="example" className="p-8">
                        <div className="flex flex-col md:max-w-3xl max-w-lg lg:mx-auto my-10 space-y-4 mx-4">
                            <div className="flex flex-col">
                                <img className="rounded-md" src="https://hncnzwww.blob.core.windows.net/www/img/products/fb-showhomes-ghb-classic-finstock7.jpg" alt="" />
                                <p className="text-gray-400 text-sm indent-2">photo credit</p>
                                <p className="text-white md:text-xl">
                                    <strong>Perfect for families</strong><br />
                                    Experience an exceptional level of luxury with GHB classic furniture.
                                </p>
                                <div className="flex flex-col font-semibold text-white text-2xl items-start">
                                    <p className="text-white md:text-xl">
                                        The Finstock is a truly unique blend of country and modern design.
                                    </p>
                                    <div className="flex flex-col space-x-4 items-center">
                                        <img className="rounded-md" src="https://hncnzwww.blob.core.windows.net/www/img/products/fb-showhomes-ghb-classic-finstock8.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabsContent>

                    <TabsContent value="code" className="p-8">
                        <div className="flex flex-col items-center px-6 whitespace-pre-line">
                            <code className="p-8 border rounded border-gray-600 w-full">
                                {`<!-- Blog Item -->
                                <div className="flex flex-col">
                                    <img className="rounded-md" src={process.env.REACT_APP_BLOB_URL + "/www/img/products/fb-showhomes-ghb-classic-finstock7.jpg"} alt="" />
                                    <p className="text-white md:text-xl">
                                        <strong>Perfect for families</strong><br />
                                        Experience an exceptional level of luxury with GHB classic furniture.
                                    </p>
                                    <div className="flex flex-col space-x-4 items-center">
                                        <img className="rounded-md" src={process.env.REACT_APP_BLOB_URL + "/www/img/products/fb-showhomes-ghb-classic-finstock8.jpg"} alt="" />
                                    </div>
                                </div>`}
                            </code>
                        </div>
                    </TabsContent>
                </Tabs>
            </div>
        </section>
    );
};

export default BlogItem;
